<div class="snack-bar-container" [ngClass]="{'completed': isCompleted}">
  <div>
    <mat-icon *ngIf="!isCompleted">picture_as_pdf</mat-icon>
    <mat-icon *ngIf="isCompleted">check_circle_outline</mat-icon>
    <span >{{ message }}</span>
  </div>
  <span class="progress-value" *ngIf="!isCompleted">{{ progress | number: '1.0-0' }} %</span>
  <span class="open" *ngIf="isCompleted && !isPageActive" (click)="onOpenClicked()">Open</span>
  <mat-icon class="close-icon-snack" [ngClass]="{'close-icon-snack-completed': isCompleted}" (click)="onClose()">close</mat-icon>
</div>
